// extracted by mini-css-extract-plugin
module.exports =  {"input":"Ye7zPWPlxpcHT4kZMiJe","label":"ItCSZtsfQhGNVe7wvuO9","hidden":"Q3obiMeyiLJXv6rq5SBr","well":"WhPX0D4ELDz1KekIZL8u"};